import type { EventPayload } from '@side/analytics';

export enum TrackDocumentsEvent {
  DocumentViewLanding,
  PrepareEnvelopeExit,
  PrepareEnvelopeSend,
  SentEnvelopeCompleted,
  SentEnvelopeReminderSent,
  ActiveDocumentsAdded,
  GenerateDocuments,
  SentEnvelopeDuplicated,
  ActiveDocumentDuplicated,
  InactiveDocumentDuplicated,
  ActiveDocumentDeleted,
  InactiveDocumentDeleted,
  ActiveDocumentsDeleteAll,
  InactiveDocumentsDeleteAll,
  SentEnvelopeDocumentDownloaded,
  SentEnvelopeDownloaded,
  SentEnvelopeCombinedDownloaded,
  ActiveDocumentDownloaded,
  InactiveDocumentDownloaded,
  ActiveDocumentsDownloadAll,
  InactiveDocumentsDownloadAll,
  ActiveDocumentForwarded,
  SentEnvelopeForwarded,
  ActiveDocumentsForwardAll,
  ActiveDocumentMoveInactive,
  InactiveDocumentMoveActive,
  ActiveDocumentsMoveAllInactive,
  InactiveDocumentsMoveAllActive,
  SentEnvelopeVoided,
  SentEnvelopeToggleView,
  AddDocumentModalChangeTabs,
  AddDocumentModalSelectUserTemplate,
  AddDocumentModalSelectTemplate,
  AddDocumentModalSelectDocument,
  AddDocumentModalSelectContract,
  ActiveDocumentUploaded,
  AddDocumentModalSelectFilter,
  ReorderActiveDocument,
  DisplayDisabledTaggingTooltip,
  GenerateOfferButtonClick,
  UpdateOfferButtonClick,
  ViewOfferDocumentsClick,
  ToggleEnvelopeForOffer,
  ToggleDocumentForOffer,
  CloseGenerateOfferModal,
  ClickGenerateOfferModal,
  ClickUpdateOfferModal,
  CloseViewOfferModal,
  CopyLinkViewOfferModal,
  EmailOfferViewOfferModal,
  NavigateToStatsPageViewOfferModal,
  SigningOrderToggle,
  SigningOrderInfoHover,
  SendEnvelope,
  PrepareEnvelopeLanding,
  PrepareEnvelopeExitConfirmation,
  PrepareEnvelopeExitCancel,
  DocumentValueUpdate,
  DocumentValueUpdateError,
  EnvelopeOverviewNameBlur,
  CustomEmailCheckboxClick,
  CustomEmailContainerClick,
  CustomEmailBodyBlur,
  CustomEmailSubjectBlur,
  ChangeSendNowCCEmailRecipient,
  ToggleEnvelopeOverviewAccordion,
  DocumentAction,
  AddDocumentModalMount,
  AddDocumentButtonClick,
  AddDocumentModalContractSearch,
  AddDocumentModalDocumentSearch,
  AddDocumentModalUploadDocument,
  AddDocumentModalClose,
  AddDocumentModalDeleteUploadedDoc,
  StaticEmailSubjectBlur,
  StaticEmailBodyBlur,
  TwoWaySyncPopupClose,
  DocumentsViewAutoTagBannerMount,
  DocumentsViewAutoTagButtonClick,
  DocumentTileAutoTagEligibleIndicatorMount,
  DocumentViewerAutoTagBannerMount,
  DocumentViewerAutoTagButtonClick,
  ValidationErrorsModalMount,
  ValidationErrorsModalGoBack,
  ValidationErrorsModalProceed,
  BypassReasonScreenMount,
  BypassReasonContinue,
  SuggestedDocumentsMount,
  SuggestedDocumentAddNow,
}

type EventTypeLabels = Record<TrackDocumentsEvent, string>;

export const DocumentsEventLabels: EventTypeLabels = {
  [TrackDocumentsEvent.DocumentViewLanding]: 'DOCUMENTS',
  [TrackDocumentsEvent.PrepareEnvelopeExit]: 'DOCUMENTS',
  [TrackDocumentsEvent.PrepareEnvelopeSend]: 'DOCUMENTS',
  [TrackDocumentsEvent.SentEnvelopeCompleted]: 'DOCUMENTS',
  [TrackDocumentsEvent.SentEnvelopeReminderSent]: 'DOCUMENTS',
  [TrackDocumentsEvent.ActiveDocumentsAdded]: 'DOCUMENTS',
  [TrackDocumentsEvent.GenerateDocuments]: 'DOCUMENTS',
  [TrackDocumentsEvent.SentEnvelopeDuplicated]: 'DOCUMENTS',
  [TrackDocumentsEvent.ActiveDocumentDuplicated]: 'DOCUMENTS',
  [TrackDocumentsEvent.InactiveDocumentDuplicated]: 'DOCUMENTS',
  [TrackDocumentsEvent.ActiveDocumentDeleted]: 'DOCUMENTS',
  [TrackDocumentsEvent.InactiveDocumentDeleted]: 'DOCUMENTS',
  [TrackDocumentsEvent.ActiveDocumentsDeleteAll]: 'DOCUMENTS',
  [TrackDocumentsEvent.InactiveDocumentsDeleteAll]: 'DOCUMENTS',
  [TrackDocumentsEvent.ActiveDocumentDownloaded]: 'DOCUMENTS',
  [TrackDocumentsEvent.InactiveDocumentDownloaded]: 'DOCUMENTS',
  [TrackDocumentsEvent.SentEnvelopeDocumentDownloaded]: 'DOCUMENTS',
  [TrackDocumentsEvent.SentEnvelopeDownloaded]: 'DOCUMENTS',
  [TrackDocumentsEvent.SentEnvelopeCombinedDownloaded]: 'DOCUMENTS',
  [TrackDocumentsEvent.ActiveDocumentsDownloadAll]: 'DOCUMENTS',
  [TrackDocumentsEvent.InactiveDocumentsDownloadAll]: 'DOCUMENTS',
  [TrackDocumentsEvent.ActiveDocumentForwarded]: 'DOCUMENTS',
  [TrackDocumentsEvent.SentEnvelopeForwarded]: 'DOCUMENTS',
  [TrackDocumentsEvent.ActiveDocumentsForwardAll]: 'DOCUMENTS',
  [TrackDocumentsEvent.ActiveDocumentMoveInactive]: 'DOCUMENTS',
  [TrackDocumentsEvent.InactiveDocumentMoveActive]: 'DOCUMENTS',
  [TrackDocumentsEvent.ActiveDocumentsMoveAllInactive]: 'DOCUMENTS',
  [TrackDocumentsEvent.InactiveDocumentsMoveAllActive]: 'DOCUMENTS',
  [TrackDocumentsEvent.SentEnvelopeVoided]: 'DOCUMENTS',
  [TrackDocumentsEvent.SentEnvelopeToggleView]: 'DOCUMENTS',
  [TrackDocumentsEvent.AddDocumentModalChangeTabs]: 'DOCUMENTS',
  [TrackDocumentsEvent.AddDocumentModalSelectUserTemplate]: 'DOCUMENTS',
  [TrackDocumentsEvent.AddDocumentModalSelectTemplate]: 'DOCUMENTS',
  [TrackDocumentsEvent.AddDocumentModalSelectDocument]: 'DOCUMENTS',
  [TrackDocumentsEvent.AddDocumentModalSelectContract]: 'DOCUMENTS',
  [TrackDocumentsEvent.ActiveDocumentUploaded]: 'DOCUMENTS',
  [TrackDocumentsEvent.AddDocumentModalSelectFilter]: 'DOCUMENTS',
  [TrackDocumentsEvent.ReorderActiveDocument]: 'DOCUMENTS',
  [TrackDocumentsEvent.DisplayDisabledTaggingTooltip]: 'DOCUMENTS',
  [TrackDocumentsEvent.GenerateOfferButtonClick]: 'SIDEBAR',
  [TrackDocumentsEvent.UpdateOfferButtonClick]: 'SIDEBAR',
  [TrackDocumentsEvent.ViewOfferDocumentsClick]: 'SIDEBAR',
  [TrackDocumentsEvent.ToggleDocumentForOffer]: 'OFFERS',
  [TrackDocumentsEvent.ToggleEnvelopeForOffer]: 'OFFERS',
  [TrackDocumentsEvent.CloseGenerateOfferModal]: 'OFFERS',
  [TrackDocumentsEvent.ClickGenerateOfferModal]: 'OFFERS',
  [TrackDocumentsEvent.ClickUpdateOfferModal]: 'OFFERS',
  [TrackDocumentsEvent.CloseViewOfferModal]: 'OFFERS',
  [TrackDocumentsEvent.CopyLinkViewOfferModal]: 'OFFERS',
  [TrackDocumentsEvent.EmailOfferViewOfferModal]: 'OFFERS',
  [TrackDocumentsEvent.NavigateToStatsPageViewOfferModal]: 'OFFERS',
  [TrackDocumentsEvent.SigningOrderToggle]: 'DOCUMENTS',
  [TrackDocumentsEvent.SigningOrderInfoHover]: 'DOCUMENTS',
  [TrackDocumentsEvent.SendEnvelope]: 'DOCUMENTS',
  [TrackDocumentsEvent.PrepareEnvelopeLanding]: 'DOCUMENTS',
  [TrackDocumentsEvent.PrepareEnvelopeExitConfirmation]: 'DOCUMENTS',
  [TrackDocumentsEvent.PrepareEnvelopeExitCancel]: 'DOCUMENTS',
  [TrackDocumentsEvent.DocumentValueUpdate]: 'DOCUMENTS',
  [TrackDocumentsEvent.DocumentValueUpdateError]: 'DOCUMENTS',
  [TrackDocumentsEvent.EnvelopeOverviewNameBlur]: 'DOCUMENTS',
  [TrackDocumentsEvent.CustomEmailCheckboxClick]: 'DOCUMENTS',
  [TrackDocumentsEvent.CustomEmailContainerClick]: 'DOCUMENTS',
  [TrackDocumentsEvent.CustomEmailBodyBlur]: 'DOCUMENTS',
  [TrackDocumentsEvent.CustomEmailSubjectBlur]: 'DOCUMENTS',
  [TrackDocumentsEvent.ChangeSendNowCCEmailRecipient]: 'DOCUMENTS',
  [TrackDocumentsEvent.ToggleEnvelopeOverviewAccordion]: 'DOCUMENTS',
  [TrackDocumentsEvent.DocumentAction]: 'DOCUMENTS',
  [TrackDocumentsEvent.AddDocumentModalMount]: 'DOCUMENTS',
  [TrackDocumentsEvent.AddDocumentButtonClick]: 'DOCUMENTS',
  [TrackDocumentsEvent.AddDocumentModalContractSearch]: 'DOCUMENTS',
  [TrackDocumentsEvent.AddDocumentModalDocumentSearch]: 'DOCUMENTS',
  [TrackDocumentsEvent.AddDocumentModalUploadDocument]: 'DOCUMENTS',
  [TrackDocumentsEvent.AddDocumentModalClose]: 'DOCUMENTS',
  [TrackDocumentsEvent.AddDocumentModalDeleteUploadedDoc]: 'DOCUMENTS',
  [TrackDocumentsEvent.StaticEmailSubjectBlur]: 'DOCUMENTS',
  [TrackDocumentsEvent.StaticEmailBodyBlur]: 'DOCUMENTS',
  [TrackDocumentsEvent.TwoWaySyncPopupClose]: 'DOCUMENTS',
  [TrackDocumentsEvent.DocumentsViewAutoTagBannerMount]: 'DOCUMENTS',
  [TrackDocumentsEvent.DocumentsViewAutoTagButtonClick]: 'DOCUMENTS',
  [TrackDocumentsEvent.DocumentTileAutoTagEligibleIndicatorMount]: 'DOCUMENTS',
  [TrackDocumentsEvent.DocumentViewerAutoTagBannerMount]: 'DOCUMENTS',
  [TrackDocumentsEvent.DocumentViewerAutoTagButtonClick]: 'DOCUMENTS',
  [TrackDocumentsEvent.ValidationErrorsModalMount]: 'DOCUMENTS',
  [TrackDocumentsEvent.ValidationErrorsModalGoBack]: 'DOCUMENTS',
  [TrackDocumentsEvent.ValidationErrorsModalProceed]: 'DOCUMENTS',
  [TrackDocumentsEvent.BypassReasonScreenMount]: 'DOCUMENTS',
  [TrackDocumentsEvent.BypassReasonContinue]: 'DOCUMENTS',
  [TrackDocumentsEvent.SuggestedDocumentsMount]: 'DOCUMENTS',
  [TrackDocumentsEvent.SuggestedDocumentAddNow]: 'DOCUMENTS',
};

type EventTypePayloads = Record<TrackDocumentsEvent, EventPayload>;

export const DocumentsEventsMap: EventTypePayloads = {
  [TrackDocumentsEvent.DocumentViewLanding]: {
    eventContainer: 'document_view',
    eventTarget: 'document_view',
    task: 'document_view_load',
    eventType: 'load',
  },
  [TrackDocumentsEvent.PrepareEnvelopeExit]: {
    eventContainer: 'envelope_preparation_page',
    eventTarget: 'unset',
    task: 'exit',
    eventType: 'click',
  },
  [TrackDocumentsEvent.PrepareEnvelopeSend]: {
    eventContainer: 'prepare_envelope_modal',
    eventTarget: 'send_envelope_button',
    task: 'send_envelope',
    eventType: 'click',
  },
  [TrackDocumentsEvent.SentEnvelopeCompleted]: {
    eventContainer: 'document_view',
    eventTarget: 'sent_envelope',
    task: 'sent_envelope_completed',
    eventType: 'result',
  },
  [TrackDocumentsEvent.SentEnvelopeReminderSent]: {
    eventContainer: 'document_view',
    eventTarget: 'sent_envelope',
    task: 'sent_envelope_reminder',
    eventType: 'click',
  },
  [TrackDocumentsEvent.ActiveDocumentsAdded]: {
    eventContainer: 'add_documents_modal',
    eventTarget: 'add_document_confirmation_button',
    task: 'document_add_confirmation',
    eventType: 'click',
  },
  [TrackDocumentsEvent.GenerateDocuments]: {
    eventContainer: 'active_documents_section',
    eventTarget: 'add_document_button',
    task: 'document_add',
    eventType: 'click',
  },
  [TrackDocumentsEvent.SentEnvelopeDuplicated]: {
    eventContainer: 'sent_envelope_section',
    eventTarget: 'duplicate_document_dropdown',
    task: 'document_duplicate',
    eventType: 'click',
  },
  [TrackDocumentsEvent.ActiveDocumentDuplicated]: {
    eventContainer: 'active_documents_section',
    eventTarget: 'duplicate_document_dropdown',
    task: 'document_duplicate',
    eventType: 'click',
  },
  [TrackDocumentsEvent.InactiveDocumentDuplicated]: {
    eventContainer: 'inactive_documents_section',
    eventTarget: 'duplicate_document_dropdown',
    task: 'document_duplicate',
    eventType: 'click',
  },
  [TrackDocumentsEvent.ActiveDocumentDeleted]: {
    eventContainer: 'active_documents_section',
    eventTarget: 'delete_document_dropdown',
    task: 'document_delete',
    eventType: 'click',
  },
  [TrackDocumentsEvent.InactiveDocumentDeleted]: {
    eventContainer: 'inactive_documents_section',
    eventTarget: 'delete_document_dropdown',
    task: 'document_delete',
    eventType: 'click',
  },
  [TrackDocumentsEvent.ActiveDocumentsDeleteAll]: {
    eventContainer: 'active_documents_section',
    eventTarget: 'delete_all_document_dropdown',
    task: 'all_document_delete',
    eventType: 'click',
  },
  [TrackDocumentsEvent.InactiveDocumentsDeleteAll]: {
    eventContainer: 'inactive_documents_section',
    eventTarget: 'delete_all_document_dropdown',
    task: 'all_document_delete',
    eventType: 'click',
  },
  [TrackDocumentsEvent.ActiveDocumentDownloaded]: {
    eventContainer: 'active_documents_section',
    eventTarget: 'download_document_dropdown',
    task: 'document_download',
    eventType: 'click',
  },
  [TrackDocumentsEvent.InactiveDocumentDownloaded]: {
    eventContainer: 'inactive_documents_section',
    eventTarget: 'download_document_dropdown',
    task: 'document_download',
    eventType: 'click',
  },
  [TrackDocumentsEvent.SentEnvelopeDocumentDownloaded]: {
    eventContainer: 'sent_envelope_section',
    eventTarget: 'download_document_dropdown',
    task: 'document_download',
    eventType: 'click',
  },
  [TrackDocumentsEvent.SentEnvelopeDownloaded]: {
    eventContainer: 'sent_envelope_section',
    eventTarget: 'download_envelope_dropdown',
    task: 'sent_envelope_download',
    eventType: 'click',
  },
  [TrackDocumentsEvent.SentEnvelopeCombinedDownloaded]: {
    eventContainer: 'sent_envelope_section',
    eventTarget: 'download_envelope_dropdown',
    task: 'sent_envelope_combined_download',
    eventType: 'click',
  },
  [TrackDocumentsEvent.ActiveDocumentsDownloadAll]: {
    eventContainer: 'active_documents_section',
    eventTarget: 'download_all_document_button',
    task: 'all_document_download',
    eventType: 'click',
  },
  [TrackDocumentsEvent.InactiveDocumentsDownloadAll]: {
    eventContainer: 'inactive_documents_section',
    eventTarget: 'download_all_document_button',
    task: 'all_document_download',
    eventType: 'click',
  },
  [TrackDocumentsEvent.ActiveDocumentForwarded]: {
    eventContainer: 'active_documents_section',
    eventTarget: 'forward_document_dropdown',
    task: 'document_download',
    eventType: 'click',
  },
  [TrackDocumentsEvent.SentEnvelopeForwarded]: {
    eventContainer: 'sent_envelope_section',
    eventTarget: 'forward_document_dropdown',
    task: 'document_download',
    eventType: 'click',
  },
  [TrackDocumentsEvent.ActiveDocumentsForwardAll]: {
    eventContainer: 'active_documents_section',
    eventTarget: 'forward_all_document_dropdown',
    task: 'all_document_download',
    eventType: 'click',
  },
  [TrackDocumentsEvent.ActiveDocumentMoveInactive]: {
    eventContainer: 'active_documents_section',
    eventTarget: 'move_document_dropdown',
    task: 'move_active_document',
    eventType: 'click',
  },
  [TrackDocumentsEvent.InactiveDocumentMoveActive]: {
    eventContainer: 'inactive_documents_section',
    eventTarget: 'move_document_dropdown',
    task: 'document_move',
    eventType: 'click',
  },
  [TrackDocumentsEvent.ActiveDocumentsMoveAllInactive]: {
    eventContainer: 'active_documents',
    eventTarget: 'move_all_document_dropdown',
    task: 'document_move',
    eventType: 'click',
  },
  [TrackDocumentsEvent.InactiveDocumentsMoveAllActive]: {
    eventContainer: 'inactive_documents',
    eventTarget: 'move_all_document_dropdown',
    task: 'document_move',
    eventType: 'click',
  },
  [TrackDocumentsEvent.SentEnvelopeVoided]: {
    eventContainer: 'document_view',
    eventTarget: 'sent_envelope',
    task: 'sent_envelope_voided',
    eventType: 'click',
  },
  [TrackDocumentsEvent.SentEnvelopeToggleView]: {
    eventContainer: 'sent_envelope_section',
    eventTarget: 'envelope_title',
    task: 'sent_envelope_view_toggle',
    eventType: 'click',
  },
  [TrackDocumentsEvent.AddDocumentModalChangeTabs]: {
    eventContainer: 'add_documents_modal',
    eventTarget: '',
    task: 'navigate_tabs',
    eventType: 'click',
  },
  [TrackDocumentsEvent.AddDocumentModalSelectUserTemplate]: {
    eventContainer: 'add_documents_modal',
    eventTarget: 'custom_template_selection',
    task: '', // dynamic
    eventType: 'click',
  },
  [TrackDocumentsEvent.AddDocumentModalSelectTemplate]: {
    eventContainer: 'add_documents_modal',
    eventTarget: 'template_selection',
    task: '', // dynamic
    eventType: 'click',
  },
  [TrackDocumentsEvent.AddDocumentModalSelectDocument]: {
    eventContainer: 'add_documents_modal',
    eventTarget: 'document_selection',
    task: '', // dynamic
    eventType: 'click',
  },
  [TrackDocumentsEvent.AddDocumentModalSelectContract]: {
    eventContainer: 'add_documents_modal',
    eventTarget: 'contract_selection',
    task: 'select',
    eventType: 'click',
  },
  [TrackDocumentsEvent.ActiveDocumentUploaded]: {
    eventContainer: 'add_documents_modal',
    eventTarget: 'upload_document_button',
    task: 'document_upload',
    eventType: 'click',
  },
  [TrackDocumentsEvent.AddDocumentModalSelectFilter]: {
    eventContainer: 'add_documents_modal',
    eventTarget: 'filter_selection',
    task: '', // dynamic
    eventType: 'click',
  },
  [TrackDocumentsEvent.ReorderActiveDocument]: {
    eventContainer: 'active_documents_section',
    eventTarget: 'document_card',
    task: 'active_document_reorder',
    eventType: 'drop',
  },
  [TrackDocumentsEvent.DisplayDisabledTaggingTooltip]: {
    eventContainer: 'document_view',
    eventTarget: 'document_tag_option',
    task: 'tag_option_hover',
    eventType: 'hover',
  },
  [TrackDocumentsEvent.GenerateOfferButtonClick]: {
    eventContainer: 'sidebar',
    eventTarget: 'generate_offer_button',
    task: 'entry',
    eventType: 'click',
  },
  [TrackDocumentsEvent.UpdateOfferButtonClick]: {
    eventContainer: 'sidebar',
    eventTarget: 'update_offer_button',
    task: 'entry',
    eventType: 'click',
  },
  [TrackDocumentsEvent.ViewOfferDocumentsClick]: {
    eventContainer: 'sidebar',
    eventTarget: 'offer_documents',
    task: 'select',
    eventType: 'click',
  },
  [TrackDocumentsEvent.ToggleDocumentForOffer]: {
    eventContainer: 'generate_offer_modal',
    eventTarget: 'document_toggle',
    task: 'entry',
    eventType: 'select',
  },
  [TrackDocumentsEvent.ToggleEnvelopeForOffer]: {
    eventContainer: 'generate_offer_modal',
    eventTarget: 'envelope_toggle',
    task: 'entry',
    eventType: 'select',
  },
  [TrackDocumentsEvent.CloseGenerateOfferModal]: {
    eventContainer: 'generate_offer_modal',
    eventTarget: 'close_modal',
    task: 'exit',
    eventType: 'select',
  },
  [TrackDocumentsEvent.ClickGenerateOfferModal]: {
    eventContainer: 'generate_offer_modal',
    eventTarget: 'generate_button',
    task: 'generate_offer',
    eventType: 'click',
  },
  [TrackDocumentsEvent.ClickUpdateOfferModal]: {
    eventContainer: 'update_offer_modal',
    eventTarget: 'update_button',
    task: 'update_offer',
    eventType: 'click',
  },
  [TrackDocumentsEvent.CloseViewOfferModal]: {
    eventContainer: 'offer_documents_modal',
    eventTarget: 'close_modal',
    task: 'exit',
    eventType: 'click',
  },
  [TrackDocumentsEvent.CopyLinkViewOfferModal]: {
    eventContainer: 'offer_documents_modal',
    eventTarget: 'copy_offer_link_button',
    task: 'copy',
    eventType: 'click',
  },
  [TrackDocumentsEvent.EmailOfferViewOfferModal]: {
    eventContainer: 'offer_documents_modal',
    eventTarget: 'email_offer_button',
    task: 'mailto',
    eventType: 'click',
  },
  [TrackDocumentsEvent.NavigateToStatsPageViewOfferModal]: {
    eventContainer: 'offer_documents_modal',
    eventTarget: 'offer_stats_link_button',
    task: 'navigate_to_stats_page',
    eventType: 'click',
  },
  [TrackDocumentsEvent.SigningOrderToggle]: {
    eventContainer: 'envelope_preparation_page',
    eventTarget: 'signing_order_toggle',
    task: 'toggle',
    eventType: 'click',
  },
  [TrackDocumentsEvent.SigningOrderInfoHover]: {
    eventContainer: 'envelope_preparation_page',
    eventTarget: 'signing_order_info_icon',
    task: 'view',
    eventType: 'hover',
  },
  [TrackDocumentsEvent.SendEnvelope]: {
    eventContainer: 'envelope_preparation_page',
    eventTarget: 'send_envelope_button',
    task: 'send_envelope',
    eventType: 'click',
  },
  [TrackDocumentsEvent.PrepareEnvelopeLanding]: {
    eventContainer: 'envelope_preparation_page',
    eventTarget: 'envelope_preparation_page',
    task: 'load',
    eventType: 'view',
  },
  [TrackDocumentsEvent.PrepareEnvelopeExitConfirmation]: {
    eventContainer: 'exit_confirmation_modal',
    eventTarget: 'continue_button',
    task: 'exit',
    eventType: 'click',
  },
  [TrackDocumentsEvent.PrepareEnvelopeExitCancel]: {
    eventContainer: 'exit_confirmation_modal',
    eventTarget: 'cancel_button',
    task: 'return',
    eventType: 'click',
  },
  [TrackDocumentsEvent.DocumentValueUpdate]: {
    eventContainer: 'document_view',
    eventTarget: 'sync_update_value',
    task: 'update',
    eventType: 'click',
  },
  [TrackDocumentsEvent.DocumentValueUpdateError]: {
    eventContainer: 'document_view',
    eventTarget: 'document_error',
    task: 'view',
    eventType: 'load',
  },
  [TrackDocumentsEvent.EnvelopeOverviewNameBlur]: {
    eventContainer: 'envelope_preparation_page',
    eventTarget: 'envelope_name',
    task: '', // set dynamically
    eventType: 'blur',
  },
  [TrackDocumentsEvent.CustomEmailCheckboxClick]: {
    eventContainer: 'envelope_preparation_page',
    eventTarget: 'custom_email_checkbox',
    task: '', // set dynamically
    eventType: 'click',
  },
  [TrackDocumentsEvent.CustomEmailContainerClick]: {
    eventContainer: 'envelope_preparation_page',
    eventTarget: 'email_container',
    task: '', // set dynamically
    eventType: 'click',
  },
  [TrackDocumentsEvent.CustomEmailBodyBlur]: {
    eventContainer: 'envelope_preparation_page',
    eventTarget: 'email_body',
    task: 'update_input',
    eventType: 'blur',
  },
  [TrackDocumentsEvent.CustomEmailSubjectBlur]: {
    eventContainer: 'envelope_preparation_page',
    eventTarget: 'email_subject',
    task: 'update_input',
    eventType: 'blur',
  },
  [TrackDocumentsEvent.ChangeSendNowCCEmailRecipient]: {
    eventContainer: 'envelope_preparation_page',
    eventTarget: 'email_recipients',
    task: '', // set dynamically
    eventType: 'input',
  },
  [TrackDocumentsEvent.ToggleEnvelopeOverviewAccordion]: {
    eventContainer: 'envelope_preparation_page',
    eventTarget: 'envelope_container',
    task: '', // set dynamically
    eventType: 'click',
  },
  [TrackDocumentsEvent.DocumentAction]: {
    eventContainer: 'documents',
    eventTarget: 'document_target',
    eventType: 'click',
    task: 'documents',
  },
  [TrackDocumentsEvent.AddDocumentModalMount]: {
    eventContainer: 'add_documents_modal',
    eventTarget: 'add_documents_modal',
    eventType: 'load',
    task: 'view',
  },
  [TrackDocumentsEvent.AddDocumentButtonClick]: {
    eventContainer: 'active_documents_section',
    eventTarget: 'add_documents_button',
    eventType: 'click',
    task: 'navigate',
  },
  [TrackDocumentsEvent.AddDocumentModalContractSearch]: {
    eventContainer: 'add_documents_modal',
    eventTarget: 'contract_search',
    eventType: 'blur',
    task: 'modify_input',
  },
  [TrackDocumentsEvent.AddDocumentModalDocumentSearch]: {
    eventContainer: 'add_documents_modal',
    eventTarget: 'document_search',
    eventType: 'blur',
    task: 'modify_input',
  },
  [TrackDocumentsEvent.AddDocumentModalUploadDocument]: {
    eventContainer: 'add_documents_modal',
    eventTarget: 'documents_upload',
    eventType: 'click',
    task: 'add',
  },
  [TrackDocumentsEvent.AddDocumentModalClose]: {
    eventContainer: 'add_documents_modal',
    eventTarget: '', // dynamic
    eventType: 'click',
    task: 'exit',
  },
  [TrackDocumentsEvent.AddDocumentModalDeleteUploadedDoc]: {
    eventContainer: 'add_documents_modal',
    eventTarget: 'uploaded_document_delete_button',
    eventType: 'click',
    task: 'delete',
  },
  [TrackDocumentsEvent.StaticEmailSubjectBlur]: {
    eventContainer: 'envelope_preparation_page',
    eventTarget: 'static_email_subject',
    eventType: 'blur',
    task: 'update_input',
  },
  [TrackDocumentsEvent.StaticEmailBodyBlur]: {
    eventContainer: 'envelope_preparation_page',
    eventTarget: 'static_email_body',
    eventType: 'blur',
    task: 'update_input',
  },
  [TrackDocumentsEvent.TwoWaySyncPopupClose]: {
    eventContainer: 'document_view',
    eventTarget: '', // dynamic
    eventType: 'click',
    task: 'exit',
  },
  [TrackDocumentsEvent.DocumentsViewAutoTagBannerMount]: {
    eventContainer: 'document_view',
    eventTarget: 'auto_tag_banner',
    eventType: 'load',
    task: 'view',
  },
  [TrackDocumentsEvent.DocumentsViewAutoTagButtonClick]: {
    eventContainer: 'auto_tag_banner',
    eventTarget: 'auto_tag_button',
    eventType: 'click',
    task: 'navigate',
  },
  [TrackDocumentsEvent.DocumentTileAutoTagEligibleIndicatorMount]: {
    eventContainer: 'document_view',
    eventTarget: 'auto_tag_eligible_indicator',
    eventType: 'load',
    task: 'view',
  },
  [TrackDocumentsEvent.DocumentViewerAutoTagBannerMount]: {
    eventContainer: 'document_viewer_page',
    eventTarget: 'auto_tag_banner',
    eventType: 'load',
    task: 'view',
  },
  [TrackDocumentsEvent.DocumentViewerAutoTagButtonClick]: {
    eventContainer: 'auto_tag_banner',
    eventTarget: 'auto_tag_button',
    eventType: 'click',
    task: 'navigate',
  },
  [TrackDocumentsEvent.ValidationErrorsModalMount]: {
    eventContainer: 'envelope_preparation_page',
    eventTarget: 'validation_error_modal',
    eventType: 'load',
    task: 'view',
  },
  [TrackDocumentsEvent.ValidationErrorsModalGoBack]: {
    eventContainer: 'validation_error_modal',
    eventTarget: 'go_back_and_review_button',
    eventType: 'click',
    task: 'navigate',
  },
  [TrackDocumentsEvent.ValidationErrorsModalProceed]: {
    eventContainer: 'validation_error_modal',
    eventTarget: 'proceed_with_errors_button',
    eventType: 'click',
    task: 'select',
  },
  [TrackDocumentsEvent.BypassReasonScreenMount]: {
    eventContainer: 'envelope_preparation_page',
    eventTarget: 'bypass_reason_screen',
    eventType: 'load',
    task: 'view',
  },
  [TrackDocumentsEvent.BypassReasonContinue]: {
    eventContainer: 'bypass_reason_screen',
    eventTarget: 'continue_with_errors_button',
    eventType: 'click',
    task: 'select',
  },
  [TrackDocumentsEvent.SuggestedDocumentsMount]: {
    eventContainer: 'envelope_preparation_page',
    eventTarget: 'suggested_documents_section',
    eventType: 'load',
    task: 'view',
  },
  [TrackDocumentsEvent.SuggestedDocumentAddNow]: {
    eventContainer: 'suggested_documents_section',
    eventTarget: 'add_now_button',
    eventType: 'click',
    task: 'add',
  },
};
